import {
  MuiFormControlLabel,
  MuiFormControl,
  MuiInputBase,
  MuiFormLabel,
  MuiAutocomplete,
  MuiOutlinedInput,
  MuiMenuItem,
  MuiChip,
  MuiTooltip,
  MuiFormHelperText,
} from '.';

const components = {
  MuiFormControlLabel,
  MuiFormControl,
  MuiInputBase,
  MuiFormLabel,
  MuiAutocomplete,
  MuiOutlinedInput,
  MuiMenuItem,
  MuiChip,
  MuiTooltip,
  MuiFormHelperText,
};

export default components;
